import { render, staticRenderFns } from "./SelectQuizGroupModal.vue?vue&type=template&id=261a31be&"
import script from "./SelectQuizGroupModal.vue?vue&type=script&lang=ts&"
export * from "./SelectQuizGroupModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports